import store from '../store/store';
// 日期字符串转时间戳
const dateToTimestamp = (ts) => {
  const d = new Date(ts);
  return parseInt(d.getTime() / 1000)
};

//图片压缩
const compressImg = (file) => {
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  let img = new Image();
  img.src = file.content;
  return new Promise(resolve => {
    img.onload = () => {
      canvas.width = 1024;
      canvas.height = 768;
      context.drawImage(img, 0, 0, 1024, 768);
      file.content = canvas.toDataURL('image/jpeg', 0.7);
      resolve(convertBase64UrlToBlob(file.content))
    }
  })
};

//base64转formData
const convertBase64UrlToBlob = (urlData) => {
  const split = urlData.split(',');
  const bytes = window.atob(split[1]);
  const ab = new ArrayBuffer(bytes.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: split[0] });
  const fd = new FormData();
  fd.append('image', blob, new Date().getTime() + '.jpg');
  return fd
};

//防抖
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let arg = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arg)
    }, delay)
  }
};

//生成随机密码
const randomCode = (pasLen) => {
  const pswArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','0','1','2','3','4','5','6','7','8','9','_','-','$','%','&','@','+','!'];
  let password = '';
  const pswArrLen = pswArr.length;
  for (let i=0; i < pasLen; i++){
    let x = Math.floor(Math.random()*pswArrLen);
    password += pswArr[x];
  }
  return password;
};

// 联系方式验证
const mobileReg = /^1[3456789]\d{9}$/;
const phoneReg = new RegExp(/^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/);
const validContactWay = (rule, value, callback)=>{
  if (!!value && !mobileReg.test(value) && !phoneReg.test(value)){
    callback(new Error('请输入正确的手机号码或固话号码'))
  }else {
    callback()
  }
};
//身份证验证
const validID = (rule, value, callback)=>{
  if(typeof value !== 'string') return '非法字符串';
  let city = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"};
  let birthday = value.substr(6, 4) + '/' + Number(value.substr(10, 2)) + '/' + Number(value.substr(12, 2));
  let d = new Date(birthday);
  let currentTime = new Date().getTime();
  let time = d.getTime();
  let newBirthday = d.getFullYear() + '/' + Number(d.getMonth() + 1) + '/' + Number(d.getDate());
  let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  let sum = 0, i, residue;
  for(i=0; i<17; i++) {
    sum += value.substr(i, 1) * arrInt[i];
  }
  residue = arrCh[sum % 11];
  if(!/^\d{17}(\d|x)$/i.test(value) || city[value.substr(0,2)] === undefined || (time >= currentTime || birthday !== newBirthday) || residue !== value.substr(17, 1)){
    callback(new Error('请输入正确身份证号码'));
  }else{
    callback();
  }
};
// 操作功能
const operatingFuncList = [
  { key: 'add', value: '新增' },
  { key: 'edit', value: '编辑' },
  { key: 'del', value: '删除' },
  { key: 'import', value: '导入' },
  { key: 'export', value: '导出' },
  { key: 'batchDel', value: '批量删除' },
];

// 操作功能名称转化
const operatingFuncName = (key) => {
  let funcName;
  operatingFuncList.forEach(i => {
    if(key === i.key) {
      funcName = i.value;
    }
  });
  return funcName;
};

// 用户的角色类型
const userRoleList = [
  {key:'enterprise',name:'企业'},
  {key:'personal',name:'个人'},
];
const takeValFromDic = (key) => {
  if(!!store.state.token && store.state.dictionaryData.length > 0){
  return store.state.dictionaryData.filter(i => i.key === key)[0].children;
  }
};
// 个人的创贷类型
const personalLoanType = [
  {key:'personalLoan',name:'个人创贷'},
  {key:'personalConvenientLoan',name:'个人便捷创贷'},
];

// 创贷流程列表
const loanProcessList = ['发起申请','人社审批','担保审批','银行授信','银行用信','反担保手续','确认放款'];

// 贴息流程列表
const discountProcessList = ['发起申请','银行审批','人社确认','担保确认','财政放款','银行出款'];

//数字每3位加逗号
const formatNum = (str) =>{
  let newStr = "";
  let count = 0;
  if(str.indexOf(".")==-1){
    for(let i=str.length-1;i>=0;i--){
      if(count % 3 == 0 && count != 0){
        newStr = str.charAt(i) + "," + newStr;
      }else{
        newStr = str.charAt(i) + newStr;
      }
      count++;
    }
    str = newStr //自动补小数点后两位
  }
  else
  {
    for(let i = str.indexOf(".")-1;i>=0;i--){
      if(count % 3 == 0 && count != 0){
        newStr = str.charAt(i) + "," + newStr;
      }else{
        newStr = str.charAt(i) + newStr; //逐个字符相接起来
      }
      count++;
    }
    str = newStr + (str + "00").substr((str + "00").indexOf("."),3);
  }
  return str;
}

//网络地址图片下载
const downloadImage = (imgSrc, name = '未命名', type = 'png') => {
  let image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL(`image/${type}`); //得到图片的base64编码数据
    let a = document.createElement("a"); // 生成一个a元素
    let event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name || "pic"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  }
  //将资源链接赋值过去，才能触发image.onload 事件
  image.src = imgSrc
}




export {
    validID,dateToTimestamp, compressImg, convertBase64UrlToBlob, debounce, randomCode, validContactWay, operatingFuncList, operatingFuncName,
   userRoleList, personalLoanType, takeValFromDic,loanProcessList,discountProcessList,formatNum,downloadImage}



// WEBPACK FOOTER //
// ./src/utils/tools.js